import React from "react";
import { Grid, Box,Hidden } from "@mui/material";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import "react-responsive-carousel/lib/styles/ca"
import { Carousel } from "react-responsive-carousel";
import FlightBooking from "../../assets/images/FlightBooking.jpg";
const CarouselInterHoliday = () => {
  return (
    // autoPlay infiniteLoop
    <Carousel autoPlay infiniteLoop >
      {[0, 1, 2, 3].map((i) => {
        return (
          <Grid container spacing={2} style={{ marginTop: 50 }}>
           <Grid item xs={12} sm={12} lg={3}>
            <Box>
                <img src='https://www.marinersforex.com/images/products/paris-477709416-590f457b3df78c92836c65e0.jpg'/>
            </Box>
            <Box style={{textAlign:'initial',padding:10}}>
                <span>5Days / 4Nights</span><br></br>
                <span>Incredible Singapore</span>
                <p>Starting From ₹24370</p>
            </Box>
           </Grid>
           <Hidden only={['xs','sm']}>
           <Grid item xs={3}>
            <Box>
                <img src='https://www.marinersforex.com/images/products/paris-477709416-590f457b3df78c92836c65e0.jpg'/>
            </Box>
            <Box style={{textAlign:'initial',padding:10}}>
                <span>5Days / 4Nights</span><br></br>
                <span>Incredible Singapore</span>
                <p>Starting From ₹24370</p>
            </Box>
           </Grid>
           <Grid item xs={3}>
            <Box>
                <img src='https://www.marinersforex.com/images/products/paris-477709416-590f457b3df78c92836c65e0.jpg'/>
            </Box>
            <Box style={{textAlign:'initial',padding:10}}>
                <span>5Days / 4Nights</span><br></br>
                <span>Incredible Singapore</span>
                <p>Starting From ₹24370</p>
            </Box>
           </Grid>
           <Grid item xs={3}>
            <Box>
                <img src='https://www.marinersforex.com/images/products/paris-477709416-590f457b3df78c92836c65e0.jpg'/>
            </Box>
            <Box style={{textAlign:'initial',padding:10}}>
                <span>5Days / 4Nights</span><br></br>
                <span>Incredible Singapore</span>
                <p>Starting From ₹24370</p>
            </Box>
           </Grid>
           </Hidden>
           
          </Grid>
        );
      })}
    </Carousel>
  );
};

export default CarouselInterHoliday;
